export const MAX_DOCUMENT_FILE_MB = 10;
export const MAX_DOCUMENT_FILE_BYTES = MAX_DOCUMENT_FILE_MB * 1024 * 1024;
export const DOCUMENT_FILE_SIZE_ERROR = 'Each file must be 10 MB or smaller.';
export const MAX_PATIENT_DOCUMENTS = 50;

export const ALLOWED_DOCUMENT_MIMES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
  'image/jpeg',
  'image/png',
  'application/xml',
  'text/xml',
];

/** File size in MB as shown in typical OS dialogs (binary, 2 decimal places). */
export function getDocumentFileSizeMb(bytes) {
  const n = Number(bytes);
  if (!Number.isFinite(n) || n < 0) return 0;
  return Number((n / (1024 * 1024)).toFixed(2));
}

/** True when the file would display as more than 10.00 MB. 9.92 MB and 10.00 MB are allowed. */
export function isFileAtOrOverDocumentLimit(file) {
  return file instanceof File && getDocumentFileSizeMb(file.size) > MAX_DOCUMENT_FILE_MB;
}

export function buildDocumentFieldErrors(documents) {
  const out = {};
  (documents || []).forEach((doc, idx) => {
    const fileKey = `documentFile_${idx}`;
    const nameKey = `documentFileName_${idx}`;
    const oversized = Boolean(doc?.fileTooLargeName) || isFileAtOrOverDocumentLimit(doc?.file);
    if (oversized) {
      out[fileKey] = DOCUMENT_FILE_SIZE_ERROR;
    }
    const fileName = (doc?.fileName || '').trim();
    if (doc?.file && !fileName) {
      out[nameKey] = 'Enter a file name for each uploaded document';
    } else if (fileName && !/^[a-zA-Z0-9 ]+$/.test(fileName)) {
      out[nameKey] = 'File name: letters, numbers, and spaces only';
    }
  });
  return out;
}

export function extractDocumentsRowsFromResponse(res) {
  const body = res?.data;
  if (!body) return [];
  if (body.success === false) return [];
  if (Array.isArray(body.data)) return body.data;
  return [];
}

export function normalizeSavedDocumentRow(doc) {
  return {
    ...doc,
    id: doc.id,
    document_name: doc.name ?? doc.document_name,
    file_name: doc.document ?? doc.file_name,
    created_at: doc.created_at,
  };
}

export function getPendingDocumentUploads(documents) {
  return (documents || [])
    .map((doc, rowIndex) => ({
      doc,
      rowIndex,
      file: doc?.file instanceof File ? doc.file : null,
      displayName: (doc?.fileName || '').trim(),
    }))
    .filter(
      ({ file, displayName }) =>
        file instanceof File &&
        !isFileAtOrOverDocumentLimit(file) &&
        Boolean(displayName)
    );
}
